import { FC } from 'react';

import operationTypes from 'constants/operationTypes';

import DefaultTableHeader from '../components/DefaultTableHeader';
import SharesTransferTableHeader from '../components/SharesTransfer/SharesTransferTableHeader';
import ReclassificationTableHeader from '../components/Reclassification/ReclassificationTableHeader';

export const historyMovementsViewExpandedTableHeaderMap: Record<string, FC> = {
  [operationTypes.CONSTITUTION]: DefaultTableHeader,
  [operationTypes.CAPITAL_INCREASE]: DefaultTableHeader,
  [operationTypes.CAPITAL_DECREASE]: DefaultTableHeader,
  [operationTypes.SELL_PARTICIPATION]: SharesTransferTableHeader,
  [operationTypes.HERITAGE]: SharesTransferTableHeader,
  [operationTypes.DONATION]: SharesTransferTableHeader,
  [operationTypes.ENDORSEMENT]: SharesTransferTableHeader,
  [operationTypes.TRANSMISSION]: SharesTransferTableHeader,
  [operationTypes.RECLASSIFICATION]: ReclassificationTableHeader,
};
